// extracted by css-extract-rspack-plugin
export default {"passwordInput":"passwordInput-o4tk0c","formInput":"formInput-csPXvu","suffix":"suffix-TZRZcp","inputIconWrap":"inputIconWrap-cWH3UC"};